import Cookie from "js-cookie";
import appConfig from "../appConfig";
import { CommonConstants } from "../constants/common";

export const USER_COOKIE_VERSION = 2;
let userCookieRevision = 0;

export function getUserCookieRevision(): number {
  return userCookieRevision;
}

export function isCompactUserCookie(value: any): boolean {
  return !!value && value.__v === USER_COOKIE_VERSION &&
    value.id !== undefined && value.id !== null;
}

// A compact cookie written from a full profile; an id-only one was rebuilt from the token.
export function isCompleteUserCookie(value: any): boolean {
  return isCompactUserCookie(value) && value.email !== undefined && value.email !== null;
}

export function getCookieValue(key: string) {
  const value = Cookie.get(key);
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}

export function getAuthToken(): string | null {
  if (typeof document === "undefined") return null;
  return Cookie.get(CommonConstants.USER_TOKEN) || null;
}


//TOD0
export function setCookieValue(key: string, value: any, expires: any = 14) {
  if (key === CommonConstants.USER_KEY) {
    if (!value || value.id === undefined || value.id === null) {
      removeCookieValue(key);
      return;
    }
    value = {
      __v: USER_COOKIE_VERSION,
      id: value.id,
      uuid: value.uuid,
      verified: value.verified,
      shouldVerify: value.shouldVerify,
      full_name: value.full_name,
      email: value.email,
      profile_image: value.profile_image,
    };

    removeCookieValue(key);
  }
  if(window.location.hostname.includes('group.app')
    || window.location.hostname.includes('group.localhost')
  ){
    Cookie.set(key, value, { path: "/", domain: appConfig.domain.baseDomain, expires, });
  }else {
    Cookie.set(key, value, { path: "/", domain: window.location.hostname, expires, });
  }
  if (key === CommonConstants.USER_KEY) userCookieRevision++;
}

export function removeCookieValue(key: string) {
  Cookie.remove(key, { path: "/" });
  Cookie.remove(key, { path: "/", domain: window.location.hostname });
  if(window.location.host.includes('group.app')
    || window.location.host.includes('group.localhost')
  ){
    Cookie.remove(key, { path: "/", domain: appConfig.domain.baseDomain });
  }else {
    Cookie.remove(key, { path: "/", domain: window.location.hostname });
  }
}
